import * as React from 'react'

import {type StoreCategoryT} from '@frontrow/console/src/entities/models/item'
import {type StoreCategoryVariationT} from '@frontrow/console/src/entities/models/store-category-variation'
import Form from './form'

type Props = {
  onSubmit: (
    name: string,
    category: string,
    storeCategory: StoreCategoryT,
    price: number,
    isHidden: boolean,
    minGrade: number,
    maxGrade: number
  ) => void
  name: string
  locizeKey: string
  category: string
  storeCategory: StoreCategoryT
  storeCategoryVariations: Array<StoreCategoryVariationT>
  price: number
  isHidden: boolean
  minGrade: number
  maxGrade: number
}

const defaultProps = {
  name: '',
  locizeKey: '',
  category: '',
  // Pick a random category...this component loads the actual item after mount.
  storeCategory: 'accessories' as StoreCategoryT,
  price: 0,
  isHidden: false,
  minGrade: 0,
  maxGrade: 12
}

function ItemFormContainer(props: Props): React.ReactElement {
  const {
    name: initialName = defaultProps.name,
    locizeKey: initialLocizeKey = defaultProps.locizeKey,
    category: initialCategory = defaultProps.category,
    storeCategory: initialStoreCategory = defaultProps.storeCategory,
    price: initialPrice = defaultProps.price,
    isHidden: initialIsHidden = defaultProps.isHidden,
    minGrade: initialMinGrade = defaultProps.minGrade,
    maxGrade: initialMaxGrade = defaultProps.maxGrade,
    storeCategoryVariations,
    onSubmit: propsOnSubmit
  } = props

  const [name, setName] = React.useState<string>(initialName)
  const [locizeKey, _setLocizeKey] = React.useState<string>(initialLocizeKey)
  const [category, setCategory] = React.useState<string>(initialCategory)
  const [storeCategory, setStoreCategory] = React.useState<StoreCategoryT>(initialStoreCategory)
  const [price, setPrice] = React.useState<number>(initialPrice)
  const [isHidden, setIsHidden] = React.useState<boolean>(initialIsHidden)
  const [minGrade, setMinGrade] = React.useState<number>(initialMinGrade)
  const [maxGrade, setMaxGrade] = React.useState<number>(initialMaxGrade)

  const onChangeName = (name: string) => {
    setName(name)
  }

  const onChangeCategory = (category: string) => {
    setCategory(category)
  }

  const onChangeStoreCategory = (storeCategory: StoreCategoryT) => {
    setStoreCategory(storeCategory)
  }

  const onChangeMaxGrade = (maxGrade: number) => {
    setMaxGrade(maxGrade)
  }

  const onChangeMinGrade = (minGrade: number) => {
    setMinGrade(minGrade)
  }

  const onChangePrice = (priceStr: string) => {
    setPrice(parseInt(priceStr, 10))
  }

  const onChangeIsHidden = () => {
    setIsHidden(prevState => !prevState)
  }

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const [isValid, errorMsg] = checkValidity(name, category, price)
    if (!isValid) {
      alert(errorMsg)
      return
    }
    propsOnSubmit(name.trim(), category.trim(), storeCategory, price, isHidden, minGrade, maxGrade)
  }

  const [isValid, _void] = checkValidity(name, category, price)

  return (
    <Form
      name={name}
      locizeKey={locizeKey}
      onChangeName={onChangeName}
      category={category}
      storeCategory={storeCategory}
      storeCategoryVariations={storeCategoryVariations}
      onChangeCategory={onChangeCategory}
      onChangeStoreCategory={onChangeStoreCategory}
      onChangeMinGrade={onChangeMinGrade}
      onChangeMaxGrade={onChangeMaxGrade}
      price={price}
      onChangePrice={onChangePrice}
      isHidden={isHidden}
      minGrade={minGrade}
      maxGrade={maxGrade}
      onChangeIsHidden={onChangeIsHidden}
      disabled={!isValid}
      onSubmit={onSubmit}
    />
  )
}

export default ItemFormContainer

function checkValidity(name: string, category: string, price: number): [boolean, string] {
  if (name.trim().length === 0 || category.trim().length === 0) {
    return [false, 'Name and Category cannot be empty']
  }

  if (price < 0) {
    return [false, 'Price cannot be negative']
  }

  if (isNaN(price)) {
    return [false, 'Price cannot be empty']
  }

  return [true, '']
}
